import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    const url = config?.url || "";
    if (response?.status !== 401 || config._retried || url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/logout")) {
      return Promise.reject(error);
    }
    config._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(config);
    } catch (refreshErr) {
      if (refreshErr?.response) window.dispatchEvent(new Event("auth:expired"));
      return Promise.reject(error);
    }
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu, lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const TRY = (v) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 2 }).format(v || 0);

export const NUM = (v) => new Intl.NumberFormat("tr-TR").format(v || 0);

export const trDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s + "T00:00:00").toLocaleDateString("tr-TR", {
      weekday: "short", day: "numeric", month: "long", year: "numeric",
    });
  } catch {
    return s;
  }
};

export const trDateLong = (d) =>
  d.toLocaleDateString("tr-TR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export const trWeekday = (s) => {
  if (!s) return "";
  try { return new Date(s + "T00:00:00").toLocaleDateString("tr-TR", { weekday: "long" }); } catch { return ""; }
};

export const isWeekend = (s) => {
  if (!s) return false;
  const d = new Date(s + "T00:00:00").getDay();
  return d === 0 || d === 6;
};
export const weekendRow = (s) => (isWeekend(s) ? " bg-amber-500/10 [&>td:first-child]:text-amber-400 [&>td:first-child]:font-semibold" : "");

export const openPdf = (blob) => {
  const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
  const w = window.open(url, "_blank", "noopener");
  if (!w) { const a = document.createElement("a"); a.href = url; a.target = "_blank"; a.rel = "noopener"; document.body.appendChild(a); a.click(); a.remove(); }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
